import axios from "axios";
// Get base URL from .env file
const baseUrl = process.env.REACT_APP_API_URL;

export const getPageViews = async () => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/ColtecAdmin/GetAllPageViews`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch page views"
    );
  }
};
